import { inject } from '../../../../../../common/container/inject';
import { ILearningRootService, LearningRootServiceToken } from '../../../../../../service/LearningRootService';
import { IProjectLearningReportArg } from '../../../../../../service/report/interface/IProjectLearningReportArg';
import { IUserRatingsDomain } from './IUserRatingsDomain';

export class UserRatingsDomain implements IUserRatingsDomain {
  constructor(
    protected learningRootService = inject<ILearningRootService>(LearningRootServiceToken),
  ) {}

  getUserRatings = (arg: IProjectLearningReportArg = {}) => this.learningRootService.report.getUserRatings(arg);
}
